module.exports = __webpack_public_path__ + "media/common/img/disabled_newsletter_settings-dc323a15886ac0e0f91dfa488e32f91f.png";